/**
 * App / company identity — the SINGLE place a fork swaps product + company
 * branding (#111 workstream A, "genericize"). Values come from VITE_* env vars
 * with the demo defaults baked in, so the demo build is unchanged and a customer
 * fork rebrands by setting env (no code edits).
 *
 * Scope: this is the user-facing CHROME identity (tab title, landing wordmark,
 * company display name). It is intentionally NOT wired into integration-logic
 * strings (e.g. "Tesseract" as a source-system id in the HCM/ERP federation
 * code) or demo-pack data (the "Mach12"/Gentex/etc. demo companies) — those are
 * semantic identifiers and demo content, genericized via demo-packs, not here.
 */
const env = import.meta.env

export const APP_IDENTITY = {
  /** Product name, e.g. the landing wordmark stem. */
  name: (env.VITE_APP_NAME as string) || 'Tesseract',
  /** Product line shown after the name (e.g. "XPM"). Empty string hides it. */
  productSuffix: env.VITE_APP_PRODUCT_SUFFIX != null ? String(env.VITE_APP_PRODUCT_SUFFIX) : 'XPM',
  /** Browser tab + document title. */
  title: (env.VITE_APP_TITLE as string) || 'Tesseract XPM',
  /** One-line product descriptor (landing tagline, meta description). */
  tagline: (env.VITE_APP_TAGLINE as string) || 'Total Program Management',
  /** Operating company shown in-product where a company name is needed. */
  company: (env.VITE_COMPANY_NAME as string) || 'Mach12',
} as const

/** "Tesseract XPM" — name + suffix joined, for headings / wordmarks. */
export function appFullName(): string {
  return APP_IDENTITY.productSuffix ? `${APP_IDENTITY.name} ${APP_IDENTITY.productSuffix}` : APP_IDENTITY.name
}
